import { capitalize } from '@cbhq/cds-utils';

import { ProjectUserDetailsNEW } from ':cloud/types/service_proto';

export function formatRole(role: string) {
  return capitalize(role.replace('ROLE_', '').toLowerCase());
}

// Returns display name in priority order: display name -> first + last (optionally truncated) -> first -> last -> '-'
// When truncating: "John Smith" becomes "John S." - uses last name part when truncating
export function getDisplayName(user: ProjectUserDetailsNEW, truncateLastName = false): string {
  const { displayName, firstName, lastName } = user;

  if (!truncateLastName) {
    return displayName || [firstName, lastName].filter(Boolean).join(' ') || '-';
  }

  const names = displayName?.trim()
    ? displayName.split(' ')
    : [firstName, lastName].filter(Boolean);
  if (names.length >= 2) return `${names[0]} ${names[names.length - 1][0]}.`;

  return displayName || firstName || lastName || '-';
}
